/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-19 09:23:05
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-09-20 14:40:21
 * @FilePath: \pit-bimwin-react-ui\src\components\PitSearchInput\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { FC, useEffect, useRef, useState, CSSProperties } from 'react';
import styles from '../../styles/PitSearchInput.module.scss';
interface PitSearchInputProps {
  placeholder?: string;
  paneData?: any;
  style?: CSSProperties;
}
const PitSearchInput: FC<PitSearchInputProps> = ({
  placeholder = '请输入',
  paneData,
}) => {
  let [count, setCount] = useState(0);
  let [over, setOver] = useState(false);
  let [data, setData] = useState([]);
  let [panelVisible, setPanelVisible] = useState(false);
  let [text, setText] = useState('');
  const inputRef = useRef(null);
  const panelRef = useRef(null);
  // 计算面板位置
  const computedPanePosition = () => {
    const dom: any = inputRef.current;
    const self: any = panelRef.current;
    self.style.width = dom.clientWidth + 'px';
  };
  useEffect(() => {
    setCount(() => 0);
    setOver(() => false);
    if (paneData.length <= 10) {
      setData(() => paneData);
    } else {
      setData(() => paneData.slice(0, 10));
    }
  }, [paneData]);
  useEffect(() => {
    setPanelVisible(() => !!text);
    setTimeout(() => {
      if (!!text) {
        computedPanePosition();
      }
    }, 0);
  }, [text]);
  useEffect(() => {
    document.addEventListener('click', (e: any) => {
      if (!e.target.closest('.search-input')) {
        setPanelVisible(false);
      }
    });
    return () => {
      document.removeEventListener('click', () => {});
    };
  }, []);
  const handelKeyDown = () => {
    setPanelVisible(true);
  };
  const handleScroll = (e: any) => {
    if (!over && e.target.scrollHeight - e.target.scrollTop - 200 <= 20) {
      setCount(() => count + 1);
      const dataCopy = paneData.slice(0, 10 * (count + 1));
      if (data.length === paneData.length) {
        setOver(true);
      }
      setData(() => dataCopy);
    }
  };
  const handlePanel = () => {
    setPanelVisible(false);
  };
  const handlChange = (e: any) => {
    console.log(11);
    setText(e.target.value);
  };
  const valueNode = data.map((item: any, index: number) => {
    return (
      <div
        className={`${styles['search-item']} pointer`}
        key={index}
        onClick={handlePanel.bind(null, item)}
      >
        <div>{item.text}</div>
        <div className={`${styles['describe']}`}>{item['parentName']}</div>
      </div>
    );
  });
  return (
    <div className={`${styles['search-input']}`} ref={inputRef}>
      <div className={`iconsousuo ${styles['mypos']} `} />

      <input
        className={`${styles['search-input-text']}`}
        onKeyDown={handelKeyDown}
        placeholder={placeholder}
        onChange={handlChange}
      />

      {/* <!-- 搜索面板 --> */}
      <div
        className={`${styles['search-panel']}`}
        onWheel={handleScroll}
        ref={panelRef}
        style={{ display: panelVisible ? 'block' : 'none' }}
      >
        <div
          className={`${styles['empty-info']}`}
          style={{ display: paneData.length === 0 ? 'block' : 'none' }}
        >
          暂未搜索到相关数据, 使用其他关键字试试吧...
        </div>
        {valueNode}
      </div>
    </div>
  );
};
PitSearchInput.defaultProps = {
  paneData: [],
};
export default PitSearchInput;
